export enum IpAddressingMethod {
  Auto = 'auto',
  Manual = 'manual',
  LinkLocal = 'link-local',
  Disabled = 'disabled',
}
